
import React from 'react';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  bold: {
    fontWeight: 'bold',
  },
  space: {
    marginLeft: 3,
  }
}));

function Score({ teams, scoringTeam, score }) {
  const classes = useStyles();
  return (
    <Typography variant="caption">
      <span
        className={clsx({[classes.bold]: teams.home === scoringTeam})}
      >
        {teams[teams.home].abbr} {score[teams.home]}
      </span>,
      <span
        className={clsx({[classes.bold]: teams.visitor === scoringTeam}, classes.space)}
      >
        {teams[teams.visitor].abbr} {score[teams.visitor]}
      </span>
    </Typography>
  )
}

export default Score;
